import { createNElements } from '@utils/createNElements';
import { SkeletonCategoriesListItem } from './SkeletonCategoriesListItem';

export const SkeletonCategoriesList = () => {
  return (
    <>
      {createNElements(5).map((_, i) => (
        <SkeletonCategoriesListItem key={i} />
      ))}
    </>
  );
};
